import { objectToQueryString } from 'modules/blipStore/resources/uri';
const SERVER_APPLICATION_URL = 'postmaster@plugins';
export class ExternalBlipStoreService {
    static $inject = ['AuthenticationService', 'BlipService', 'BLIP_DOMAIN'];
    constructor(AuthenticationService, BlipService, BLIP_DOMAIN) {
        this.AuthenticationService = AuthenticationService;
        this.BlipService = BlipService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
    }
    async connectBlipClient() {
        if (!(await this.BlipService.isConnected())) {
            await this.BlipService.connect(encodeURIComponent(this.AuthenticationService.email), this.AuthenticationService.token);
        }
    }
    async GetExtensionsByParameter(tenantId, language, journey) {
        await this.connectBlipClient();
        const params = {
            language: language,
            journey: journey,
            charge: 'all',
        };
        const commandResponse = await this.BlipService.processCommand({
            to: `${SERVER_APPLICATION_URL}.${this.BLIP_DOMAIN}`,
            method: 'get',
            uri: `/tenants/${tenantId}/plugins/recommended${objectToQueryString(params)}`,
        });
        this.BlipService.ensureCommandSuccess(commandResponse);
        return commandResponse.resource.items;
    }
}
ExternalBlipStoreService.$inject = ['AuthenticationService', 'BlipService', 'BLIP_DOMAIN'];
